export default "__VITE_ASSET__C3pO0msf__"